module.exports = __webpack_public_path__ + "img/ham_menu.dd8d6a6f.svg";